var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#9E9E9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7773 23.7773L20.2218 23.7773L20.2218 19.3329L23.7773 19.3329L23.7773 9.11068L10.8639 9.11068C9.65391 9.11068 8.62599 9.99591 8.4465 11.1925L7.6465 16.5258C7.42481 18.0038 8.56945 19.3329 10.0639 19.3329L15.3329 19.3329L15.3329 21.3329C15.3329 22.6829 16.4273 23.7773 17.7773 23.7773ZM18.8885 10.444L10.8639 10.444C10.3139 10.444 9.84667 10.8464 9.76508 11.3903L8.96508 16.7236C8.86432 17.3954 9.3846 17.9996 10.0639 17.9996L16.6662 17.9996L16.6662 21.3329C16.6662 21.9465 17.1637 22.444 17.7773 22.444L18.8885 22.444L18.8885 10.444ZM20.2218 10.444L20.2218 17.9996L22.444 17.9996L22.444 10.444L20.2218 10.444Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.a2a079f31904450c839a64d333cc89c0.svg";
export { ForwardRef as ReactComponent };